document.addEventListener("DOMContentLoaded", () => {
  const wishlistButtons = document.querySelectorAll('.wishlist-btn');
  
  if (wishlistButtons.length === 0) return; // Exit if no buttons exist

  // Delay the check until _swat is available (in case it's loading asynchronously)
  setTimeout(() => {
    if (typeof _swat !== 'undefined') {
      // Fetch wishlist state on page load
      _swat.fetchWrtEventTypeET(fetchCallbackFn, 4);
    }
  }, 1000);

  // Loop through each button and add event listeners
  wishlistButtons.forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();


      if (!event.currentTarget) return; // Exit if the button doesn't exist

      let wlBtnEl = event.currentTarget;
      let productId = wlBtnEl.dataset.productId;
      let variantId = wlBtnEl.dataset.variantId;
      let price = wlBtnEl.dataset.price;
      let image = wlBtnEl.dataset.image;
      let productTitle = wlBtnEl.dataset.productTitle || "Product"; // Default value if undefined

      if (!productId || !variantId || !price || !image) return; // Exit if data attributes are missing

      let swymPageData = {
          empi: productId,
          epi: variantId,
          pr: price,
          iu: image
      };

      if (typeof _swat === 'undefined') return; // Exit if Swym API is not loaded

      // Check if the product is already in the wishlist
      if (wlBtnEl.dataset.isInWishlist === 'true') {
          _swat.removeFromWishList(swymPageData, function(){
              wlBtnEl.classList.remove('saved');
              wlBtnEl.setAttribute('data-is-in-wishlist', 'false');
              window.HeaderWishlist?.sync();
          });
      } else {
          _swat.addToWishList(swymPageData, function(){
              wlBtnEl.classList.add('saved');
              wlBtnEl.setAttribute('data-is-in-wishlist', 'true');
              window.HeaderWishlist?.sync();
              createWLNotifyPopup(swymPageData, productTitle.trim()); // Trim to avoid empty spaces
          });
      }
    });
  });
});

let mainElement = document.querySelector('.product-main-element');

if (mainElement) {
    mainElement.addEventListener('variantChange', event => { 
        let currentVariant = event.detail.variant;

        let wishlistBtn = mainElement.querySelector('.wishlist-btn');
        if (wishlistBtn) {
            wishlistBtn.setAttribute('data-variant-id', currentVariant.id);
            wishlistBtn.setAttribute('data-price', currentVariant.price);
            wishlistBtn.setAttribute('data-image', currentVariant.featured_image.src);
        }
    });
}


// Function to update wishlist button states
function fetchCallbackFn(products) {

  const wishlistButtons = document.querySelectorAll('.wishlist-btn');

  if (!wishlistButtons.length) return; // Exit if there are no buttons

  wishlistButtons.forEach(wlBtnEl => {
    let productId = wlBtnEl.dataset.productId;
 
    // Check if the product is in the wishlist
    let isInWishlist = products.find(p => p.empi == productId);

    if (isInWishlist) {
        wlBtnEl.classList.add('saved');
        wlBtnEl.setAttribute('data-is-in-wishlist', 'true');
    } else {
        wlBtnEl.classList.remove('saved');
        wlBtnEl.setAttribute('data-is-in-wishlist', 'false');
    }
  });
}

// Wishlist notification popup
function createWLNotifyPopup(swymPageData, productTitle) {
  if (!swymPageData.iu) return; // Exit if there's no image URL

  let notifyPopup = document.createElement('div');
  notifyPopup.innerHTML = `
  <div class="flex align-items-start justify-content-between">
      <div class="one-third">
          <img src="${swymPageData.iu}" />
      </div>
      <div class="two-thirds">
        <div><strong>${productTitle}</strong> has been added to your list.</div>
      </div>
  </div>`;
  notifyPopup.classList.add('wishlist-notify');
  document.body.appendChild(notifyPopup);
  setTimeout(() => {
      notifyPopup.remove();
  }, 4000);
}
